import type { Translations } from '$lib/types/globalTypes';

export function getText(globalTexts: Translations, key: string) {
  if (key in globalTexts) {
    return globalTexts[key];
  } else {
    return {
      isRichtext: false,
      text: '[' + key + ']'
    };
  }
}